export const initial_state = {
    posts: [],
    mainPost: null,
    topPosts: [],
    total: 0,
    hasMore: false,
    page: 1,
    shouldUpdateProgressBar: false
};

export function postReducer(state, action) {
    switch (action.type) {
        case 'ADD_POSTS':
            return {
                ...state,
                posts: action.payload.posts,
                total: action.payload.total,
                hasMore: action.payload.hasMore,
                page: action.payload.page,
                shouldUpdateProgressBar: false
            };
        case 'SHOULD_UPDATE_PROGRESS_BAR':
            return {
                ...state,
                shouldUpdateProgressBar: !state.shouldUpdateProgressBar
            };
        case 'ADD_MAIN_POST':
            return {
                ...state,
                mainPost: action.payload.post,
            };
        case 'ADD_TOP_POSTS':
            return {
                ...state,
                topPosts: action.payload.posts,
            }
    }
}